import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import React from 'react';
import OrderRequest from '../CloudDiscovery/OrderRequest';
import Material from '../CloudPlaner/Material';
import Operations from '../CloudPlaner/Operations';
import WorkOrders from '../CloudPlaner/WorkOrders';
import AssetStrategies from '../MaintanceStrategies/AssetStrategies';
interface IProp {
  asset_code: string | undefined;
}
function AssetsIntelligenceTabs({ asset_code }: IProp) {
  return (
    <div>
      <TabComponent animation={{ next: { effect: 'None' } }}  statelessTemplates={['directiveTemplates']}>
        <TabItemsDirective>
          <TabItemDirective
            header={{ text: 'Request Management' }}
            content={() => {
              return (
                <div>
                  <OrderRequest outter_asset_code={asset_code}  first_load_request={false}/>
                </div>
              );
            }}
          />
          <TabItemDirective
            header={{ text: 'Request Management' }}
            content={() => {
              return <div></div>;
            }}
          />
          <TabItemDirective
            header={{ text: 'Mobile App Requests' }}
            content={() => {
              return <div></div>;
            }}
          />
          <TabItemDirective
            header={{ text: 'Work Orders' }}
            content={() => {
              return <div>
                <WorkOrders outter_asset_code={asset_code} needDidMount={true}/>
              </div>;
            }}
          />
          <TabItemDirective
            header={{ text: 'Operations' }}
            content={() => {
              return <div>
                <Operations needDidMount={true} outter_asset_code={asset_code}/>
              </div>;
            }}
          />
          <TabItemDirective
            header={{ text: 'Material' }}
            content={() => {
              return <div>
                <Material outter_asset_code={asset_code}/>
              </div>;
            }}
          />
          <TabItemDirective
            header={{ text: 'Asset Strategies' }}
            content={() => {
              return <div>
                <AssetStrategies outter_asset_code={asset_code} first_load_request={false}/>
              </div>;
            }}
          />
          <TabItemDirective
            header={{ text: 'Service is PM' }}
            content={() => {
              return <div></div>;
            }}
          />
          <TabItemDirective
            header={{ text: `CC's PM` }}
            content={() => {
              return <div></div>;
            }}
          />
          <TabItemDirective
            header={{ text: `BOMS` }}
            content={() => {
              return <div></div>;
            }}
          />
          <TabItemDirective
            header={{ text: `Spare Parts` }}
            content={() => {
              return <div></div>;
            }}
          />
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
}

export default  React.memo(AssetsIntelligenceTabs);
